import React, { createContext, useContext, useState } from "react";
import { IEventContext, IEventData } from "../exports/interfaces";

const EventContext = createContext<IEventContext>({
  eventData: [],
  setEventData: () => null,
});
export const useEventContext = () => useContext(EventContext);

export const EventProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [eventData, setEventData] = useState<IEventData[]>([]);

  return (
    <EventContext.Provider value={{ eventData, setEventData }}>
      {children}
    </EventContext.Provider>
  );
};